/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { decrypt, getQueryString } from '@shared/utils';
import { SHARE_CHANNEL_TYPE, SPDB_WHITE_LIST } from '@shared/config';
import { stringifyUrl, parseUrl } from 'query-string';
import {
  isZXRecommendCustomerProduct,
  zxAesKeyAndIv,
  encryptParamBase64,
  encryptParamHex,
} from './localBankCustomization';
import { useProductCommonStore, useUserStore, useGlobalStore } from '@shared/store';
import { marketingProductApi } from '@shared/apis';

// 台州银行跳转链接拼接参数取员工账号字段userid
const corpIdArrayIncludeTZ = ['ww8c83d949a80b562d', 'ww2c6ff24bf8608b5b', 'wx7d9635003a1eb42e'];
const currentCorpId = getQueryString('currentCorpId', localStorage.getItem('entrySearch') || window.location.search);
const isTZ = corpIdArrayIncludeTZ.includes(currentCorpId);
const xiaMenCorpIdArray = ['ww9d09288d837bf4da']; // 厦门银行、uat
const isXiaMenBank = xiaMenCorpIdArray.includes(currentCorpId);

// 光大银行通过后端直接加密跳转链接, 不走新的加密接口
const corpIdArrayIncludeGD = ['ww7726587648cdc3da'];
// 浦发银行
const isGD = corpIdArrayIncludeGD.includes(currentCorpId);
const isSPDB = SPDB_WHITE_LIST.includes(currentCorpId);

export const getEncryptionLink = async ({ productId, source }: any) => {
  try {
    const userStore = useUserStore();
    const shareChannels = getQueryString('shareChannels', window.location.search);
    const params = {
      productId,
      staffId: userStore.viewStaffInfo.staffId,
      shareChannelType: SHARE_CHANNEL_TYPE[shareChannels] || 'UNKNOWN',
      shareSourceType: Number(source),
    };

    const res = await marketingProductApi.performanceEncryptionApi(params);
    return res.retdata.encryptionLink;
  } catch (error) {
    console.error('%c performanceEncryptionApi error:', 'color: #0e93e0;background: #aaefe5;', error);
  }
};

type PropsType = {
  productLink: string;
  productDetail: any;
  attributionValue: string;
  alias: string | undefined;
  source: string | undefined;
};

// 获取跳转行方产品额外的参数
export const getProductJumpParams: (props: PropsType) => Promise<string> = async ({
  productLink,
  productDetail,
  attributionValue,
  alias = '',
  source,
}) => {
  const { jumpLinkType, code, id: productId, category } = productDetail;
  const productCommonStore = useProductCommonStore();
  const userStore = useUserStore();
  const globalStore = useGlobalStore();
  const userId = userStore.viewStaffInfo?.userId;
  let url = productLink;
  // 跳转
  if (productLink && jumpLinkType !== 2) {
    // 外链
    const newAttr = attributionValue.split(';');
    let newAttrParam = '';
    newAttr.forEach((item, i) => {
      const noLastIndex = i !== newAttr.length - 1;
      // 中信和台州的不取别名，取账号名称
      if (item)
        newAttrParam += `${item}=${encodeURIComponent(productCommonStore.isZX || isTZ ? userId : alias)}${
          noLastIndex ? '&' : ''
        }`;
    });

    if (productCommonStore.isZX) {
      if (jumpLinkType === 1) {
        const productLinkArr = productLink.split('?');
        productLinkArr[1] += `&${newAttrParam}&productCode=${code}`;
        // 网址+加密参数+固定常数
        console.log('加密前：', productLinkArr[1]);
        console.log('加密后：', encryptParamBase64(productLinkArr[1]));
        let newUrl = '';
        const { zxBankOrgInfo } = productCommonStore;
        if (isZXRecommendCustomerProduct(productLink) && zxBankOrgInfo.encryptUserInfo) {
          const { query } = parseUrl(productLink);
          const data = {
            params: { CATYNO: query.CATYNO, CPROTP: query.CPROTP },
            userinfo: JSON.parse(decrypt(zxBankOrgInfo.encryptUserInfo, zxAesKeyAndIv.key, zxAesKeyAndIv.iv)),
          };
          newUrl = productLinkArr[0] + '?index=' + query.index + '-extra-' + encryptParamHex(JSON.stringify(data));
        } else {
          newUrl = productLinkArr[0] + '?' + encryptParamBase64(`${productLinkArr[1]}&channel=cfxz_app`);
        }
        url = newUrl;
      } else if (jumpLinkType === 3) {
        url = productLink;
      }
    } else if (isXiaMenBank) {
      // 【厦门银行】唤醒手机银行app参数对接 https://www.tapd.cn/61702827/prong/stories/view/1161702827001010306
      try {
        const xiaMenParams = { pdId: code, cmId: userId };
        const { url: linkUrl } = parseUrl(productLink);
        // base64转码 https://www.zhangxinxu.com/wordpress/2018/08/js-base64-atob-btoa-encode-decode/
        const paramsWithBase64 = window.btoa(unescape(encodeURIComponent(JSON.stringify(xiaMenParams))));
        const xiaMenBankLink = stringifyUrl({ url: linkUrl, query: { args: paramsWithBase64 } }, { encode: false });
        console.log('%c xiaMenBankLink:', 'color: #fff;background: #b457ff;', xiaMenBankLink);
        url = xiaMenBankLink;
      } catch (error) {
        console.error('%c 厦门银行链接拼接失败 error:', 'color: #fff;background: #b457ff;', error);
      }
    } else if (isGD) {
      // 避免去掉会对光大跳转产生影响, 把以前的逻辑加上
      url = attributionValue
        ? productLink + `${productLink.includes('?') ? '&' : '?'}${newAttrParam}&productCode=${code}`
        : productLink;
    } else {
      url = await getEncryptionLink({ productId, source });
    }
  }
  return url;
};
